import { Message } from "@websim/core/src/sites/message";
import { parentApi } from "./message-proxy";
export interface IChatCompletion {
  completions: {
    create: ({
      messages,
      json,
    }: {
      messages: Message[];
      json?: boolean;
    }) => Promise<Message>;
  };
}
export class Chat implements IChatCompletion {
  completions = {
    create: async ({
      messages,
      json,
    }: {
      messages: Message[];
      json?: boolean;
    }) => {
      return parentApi.chatCompletion({ messages, json });
    },
  };
}
